import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./ContactPage.css";

const ContactPage: React.FC = () => {
  const heroBg = `${process.env.PUBLIC_URL}/images/contactus.webp`;
  const locationBg = `${process.env.PUBLIC_URL}/images/Aberdeen-Residences/aberdeen-residences.webp`;

  return (
    <div className="contact-page">
      <Header />

      {/* Hero Section */}
      <section
        className="contact-hero"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center bottom",
          height: "65vh",
          position: "relative",
        }}
      >
        <div className="hero-overlay">
          <h1 className="hero-title">Contact Us</h1>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info">
        <div className="section-block">
          <p className="section-label">Contact</p>
          <h2 className="section-title">Let’s start a new project.</h2>
          <p className="section-description">
            Now, as you were able to get a picture of who we are, it is up to
            you to contact us and lay the foundation for a new and successful
            business relationship. Our team consists…
          </p>

          <div className="info-grid">
            <div className="info-block">
              <h4>Phone</h4>
              <p>+961 (5) 453 306</p>
              <p>+961 (71) 077 605</p>
            </div>
            <div className="info-block">
              <h4>Email</h4>
              <p>
                <a href="mailto:info@nextudio.co" className="link-plain">
                  info@nextudio.co
                </a>
              </p>
            </div>
            <div className="info-block">
              <h4>Whatsapp</h4>
              <p>+961 71 077 605</p>
            </div>
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="location-info">
        <div className="section-block">
          <p className="section-label">Locations</p>
          <h2 className="section-title">Meet Us in your City.</h2>

          {/* Simple, reliable card: background image inline */}
          <a
            className="location-card"
            href="https://maps.app.goo.gl/61HTTuDWz4YzUUfA8"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Nextudio Architects location in Google Maps"
            style={{
              backgroundImage: `url(${locationBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="location-overlay" />
            <div className="location-content">
              <p className="loc-title">Beirut – Lebanon</p>
              <p>Hazmieh | Said Freiha street</p>
              <p>Ferekh bldg. | First Floor</p>
              <p>Next to Camelia 2 Bldg.</p>

              <span className="location-cta">
                <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
                <span>Open in Maps</span>
              </span>
            </div>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
